<template>
  <div>
    <v-chip
      class="ml-2"
      v-for="(filter, index) in filters"
      :key="index"
      close
      small
      @click:close="removeFilterByID(filter.id)"
      >{{ filter.label }}</v-chip
    >
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  methods: {
    removeFilterByID(id) {
      this.$store.dispatch("filters/removeFilterByID", id);
      this.$emit("filtersUpdated");
      this.$emit("fetchLinks");
    },

    testMethod() {
      console.log(this.filters);
    },
  },
  computed: {
    ...mapGetters({
      filters: "filters/displayed",
    }),
  },
};
</script>

<style></style>
